import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  CircularProgress,
  TextField,
  Switch,
  FormControlLabel
} from "@material-ui/core";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },

  multFieldLine: {
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const SessionSchema = Yup.object().shape({
  nickname: Yup.string()
    .min(2, i18n.t("validation.too_short"))
    .max(30, i18n.t("validation.too_long"))
    .required(i18n.t("validation.required")),
  name: Yup.string()
    .min(2, i18n.t("validation.too_short"))
    .required(i18n.t("validation.required"))
});

const TenantModal = ({ open, onClose, tenantId }) => {
  const classes = useStyles();
  const initialState = {
    name: "",
    nickname: "",
    whatsapp: "",
    email: "",
    description: "",
    status: true,
  };
  const [tenant, setTenant] = useState(initialState);

  useEffect(() => {
    const fetchSession = async () => {
      if (!tenantId) return;

      try {
        const { data } = await api.get(`tenants/${tenantId}`);
        console.log("setTenant", data)
        setTenant(data);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [tenantId]);

  const handleSaveTenant = async (values) => {
    // const tenantData = { ...values, tenant };
    try {
      if (tenantId) {
        await api.put(`/tenants/${tenantId}`, values);
      } else {
        await api.post("/tenants", values);
      }
      toast.success(i18n.t("tenantModal.success"));
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleClose = () => {
    onClose();
    setTenant(initialState);
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          {tenantId
            ? `${i18n.t("global.buttons.edit")} ${i18n.t("tenant.name")}`
            : `${i18n.t("global.buttons.add")} ${i18n.t("tenant.name")}`
          }
        </DialogTitle>
        <Formik
          initialValues={tenant}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveTenant(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (

            <Form>
              <DialogContent dividers>
                <div className={classes.multFieldLine} style={{ minWidth: "200px" }}>
                  <Field
                    as={TextField}
                    label={i18n.t("global.nickname")}
                    autoFocus
                    name="nickname"
                    error={touched.nickname && Boolean(errors.nickname)}
                    helperText={touched.nickname && errors.nickname}
                    variant="outlined"
                    margin="dense"
                  />
                  <FormControlLabel
                    control={
                      <Field
                        as={Switch}
                        color="primary"
                        name="status"
                        checked={values.status}
                      />
                    }
                    label="Status"
                  />
                </div>
                <Field
                  fullWidth
                  as={TextField}
                  label={i18n.t("global.name")}
                  name="name"
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                  variant="outlined"
                  margin="dense"
                />
                <Field
                  fullWidth
                  as={TextField}
                  label="whatsapp"
                  name="whatsapp"
                  error={touched.whatsapp && Boolean(errors.whatsapp)}
                  helperText={touched.whatsapp && errors.whatsapp}
                  variant="outlined"
                  margin="dense"
                />
                                <Field
                  fullWidth
                  as={TextField}
                  label="email"
                  name="email"
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                  variant="outlined"
                  margin="dense"
                />


                <div>
                  <Field
                    as={TextField}
                    label={i18n.t("global.description")}
                    multiline
                    minRows={5}
                    fullWidth
                    name="description"
                    error={
                      touched.description && Boolean(errors.description)
                    }
                    helperText={
                      touched.description && errors.description
                    }
                    variant="outlined"
                    margin="dense"
                  />
                </div>
 

              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("global.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  className={classes.btnWrapper}
                >
                  {tenantId
                    ? i18n.t("global.buttons.okEdit")
                    : i18n.t("global.buttons.okAdd")}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default React.memo(TenantModal);
